import Address from './Address';
Address.install = (Vue)=>{
    Vue.components(Address.name,Address)
}
export default Address;
